// src/components/ClientPortalTasks.js

import React from 'react';

function ClientPortalTasks({ currentUser, clients, tasks, cases }) {
  // Find the specific client profile linked to the current user
  const clientProfile = clients.find(client => client.user === currentUser.id);

  // Filter tasks relevant to this specific client profile's cases
  const clientTasks = tasks.filter(task =>
    task.case && cases.some(c => c.id === task.case && c.client === (clientProfile ? clientProfile.id : null))
  );

  return (
    <div>
      <h2 className="text-2xl font-bold text-primary mb-1">Your Tasks</h2>
      {clientProfile ? (
        <p className="text-gray-500 mb-6">View tasks assigned to your cases, {clientProfile.first_name} {clientProfile.last_name}.</p>
      ) : (
        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6">
          <p className="text-yellow-700">Your user account is not yet linked to a client profile. Please contact the firm administrator to view your tasks.</p>
        </div>
      )}

      {clientTasks.length > 0 ? (
        <div className="bg-white rounded-lg shadow border border-gray-200 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full">
              <thead className="bg-primary text-white">
                <tr>
                  <th className="px-4 py-3 text-left text-sm font-semibold">Title</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold">Associated Case</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold">Due Date</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold">Status</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold">Priority</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold">Assigned To</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {(clientTasks || []).map(task => (
                  <tr key={task.id} className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm text-gray-800">{task.title}</td>
                    <td className="px-4 py-3 text-sm text-gray-600">{task.case_title || 'N/A'}</td>
                    <td className="px-4 py-3 text-sm text-gray-600">{task.due_date}</td>
                    <td className="px-4 py-3 text-sm text-gray-600">{task.status}</td>
                    <td className="px-4 py-3 text-sm text-gray-600">{task.priority}</td>
                    <td className="px-4 py-3 text-sm text-gray-600">{task.assigned_to_username || 'N/A'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 text-center">
          <p className="text-blue-700">No tasks found associated with your client profile's cases.</p>
        </div>
      )}
    </div>
  );
}

export default ClientPortalTasks;
